import { useQuery, useQueryClient } from "@tanstack/react-query"
import { useEffect } from "react"

import { getUserInfo } from "@/api"
import { useAuthStore, useCurrentUser } from "@/modules/helpers/hooks/shared"
import { sendLogout } from "@/modules/helpers/utils"
import { User } from "@/modules/types"

const QUERY_CONFIG = {
  gcTime: 80000,
  staleTime: 80000
}

const useSyncUser = () => {
  const queryClient = useQueryClient()
  const { accessToken, resetAll } = useAuthStore()
  const { setUser } = useCurrentUser()
  const { data, isSuccess } = useQuery({
    queryKey: ["user_info"],
    queryFn: getUserInfo,
    ...QUERY_CONFIG,
    enabled: !!accessToken,
    retry: false // Disable retry to see error immediately
  })

  const user = data?.data?.data

  useEffect(() => {
    if (!accessToken) {
      queryClient.clear()
      sendLogout()
      return
    }

    if (isSuccess) {
      const isNotValidUser = user?.id === "undefined"

      if (isNotValidUser) {
        resetAll()
      } else {
        setUser(user as User)
      }
    }
  }, [accessToken, user, isSuccess, queryClient, resetAll, setUser])
}

export default useSyncUser
